import { ROUTES } from "@/shared/constants/routes";
import RocketIcon from "@/shared/icons/rocket";
import SessionsIcon from "@/shared/icons/sessions";
import SettingsIcon from "@/shared/icons/settings";
import TeamIcon from "@/shared/icons/team";
import { Sparkles, StoreIcon } from "lucide-react";
import { NavItemData } from "../types/sidebar";

export const sidebarItems: NavItemData[] = [
  {
    title: "AI Agent",
    Icon: RocketIcon,
    path: ROUTES.AGENT,
  },
  {
    title: "Sessions",
    Icon: SessionsIcon,
    path: ROUTES.AGENT_SESSIONS,
  },
  {
    title: "Vendors",
    Icon: StoreIcon,
    path: ROUTES.VENDORS,
    canAccess: (permissions) => permissions.canAccessZaniaVendorAssessment,
  },
  // {
  //   title: 'Dashboard',
  //   path: ROUTES.DASHBOARD,
  //   Icon: DashboardIcon,
  // },
  // {
  //   title: 'Workflows',
  //   path: ROUTES.WORKFLOWS,
  //   Icon: LighteningIcon,
  // },
  // {
  //   title: 'Integrations',
  //   path: ROUTES.INTEGRATIONS,
  //   Icon: PuzzlePieceIcon,
  // },
  // {
  //   title: 'Knowledge Base',
  //   label: '',
  //   path: ROUTES.KNOWLEDGE_BASE,
  //   Icon: KnowledgeBaseIcon,
  // },
  {
    title: "Team",
    label: "",
    path: ROUTES.TEAM,
    Icon: TeamIcon,
  },
  {
    // Remove the inline beta styling and use a proper component structure
    title: (
      <div className="flex items-center gap-2">
        <span>Ask Zania</span>
        <div className="flex justify-center items-center px-2 gap-1 w-[42px] h-5 bg-[#FAFAFA] border-[0.5px] border-[#E4E4E7] rounded-[4px]">
          <span 
            className="w-[26px] h-5 font-medium text-[10px] leading-5 uppercase"
            style={{
              fontFamily: 'Inter',
              background: 'linear-gradient(180deg, #FF6496 0%, #812DD6 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}
          >
            BETA
          </span>
        </div>
      </div>
    ),
    label: "",
    path: ROUTES.ASK_AI,
    Icon: Sparkles,
    canAccess: (permissions) => permissions.canAccessZaniaAskAi,
  },
  {
    title: "Settings",
    label: "",
    path: ROUTES.SETTINGS,
    Icon: SettingsIcon,
  }
];
